var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiArrowSwitchHorizontal = function SvgAiArrowSwitchHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#C77AC4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.25 10.5 6 8.25m0 0L8.25 6M6 8.25h12m-2.25 5.25L18 15.75m0 0L15.75 18M18 15.75H6"
  })));
};
export default SvgAiArrowSwitchHorizontal;